import React from "react";
import { Link } from "react-router-dom";

// A Google Business Profile reviews link can be set as REACT_APP_GOOGLE_REVIEWS_URL.
// Without it, this opens the shop's Google Maps listing, which shows its reviews.
export const GOOGLE_REVIEWS_URL =
  process.env.REACT_APP_GOOGLE_REVIEWS_URL ||
  "https://www.google.com/maps/search/?api=1&query=Technogenious%20Solutions%20Ltd%2C%2017%20Molynes%20Road%2C%20Kingston%2C%20Jamaica";

/**
 * Reasons to buy with confidence, shown beside the buy button. Every line
 * restates something published elsewhere on the site (licence, Pyramid
 * authorisation, returns terms, pickup); nothing here is a new promise.
 */
export default function ProductTrust() {
  return (
    <ul className="pd-trust" aria-label="Why buy from Technogenious">
      <li><strong>BGLC licensed</strong><span>Technical service provider for gaming machines</span></li>
      <li><strong>Authorised Pyramid centre</strong><span>Sales and service for bill validators and printers</span></li>
      <li><strong>15-day returns on standard parts</strong><span><Link to="/warranties">Change-of-mind terms apply</Link></span></li>
      <li><strong>Free pickup in Kingston</strong><span>Shop 4B, 17 Molynes Road</span></li>
      <li className="pd-trust-reviews"><a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer">See our Google reviews ↗</a></li>
    </ul>
  );
}
